import axios from 'axios';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components'

import {Flex, Text, Spinner} from "../../../../components";
import KeyPath from "./KeyPath";

const Header = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 15px 30px;
`;

const Search = styled.input`
  background: transparent;
  flex-grow: 1;
  margin-right: 20px;
  height: 100%;
  color: #fff;
  
  &::placeholder {
    color: #7178B2
  }
`;

const Button = styled.button`
  border-radius: 4px;
  padding: 0 18px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 12px;
  font-weight: 600;
  background: ${props => props.bg}
`;

const Content = styled(Flex)`
  padding: 30px;
`;

const HeaderRow = styled(Flex)`
  border-bottom: 1px solid #414568;
  padding: 18px 24px;
  margin-bottom: 24px;
  color: #7178B2;
  font-weight: 600;
  font-size: 12px;
`;

const KeyPaths = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [licensesPaths, setLicensesPaths] = useState(null);

  useEffect(() => {
    axios
      .get('/api/admin/licenses/key-paths')
      .then(res => {
          setLicensesPaths(res.data.licensesPaths);
          setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  if (isLoading) return (
    <Spinner></Spinner>
  );

  return (
    <>
      <Content w="100%" minw="660px" dir="column">
        <HeaderRow w="100%" minw="600px">
          <Flex w="40%">
            <Text.Body>Current Key</Text.Body>
          </Flex>
          <Flex w="40%">
            <Text.Body>Discord ID (Current Owner)</Text.Body>
          </Flex>
        </HeaderRow>
        {licensesPaths.map((value) => {
          return <KeyPath data={value} />
        })}
      </Content>
    </>
  )
}

export default KeyPaths;
